import { axios, axios_v2, getSessionToken } from '../utils/http';

export const uploadFile = async (payload) => {
  try {
    const token = await getSessionToken();

    const res = await axios_v2.post(`/envelope/upload-file`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getAvailableFiles = async (boardId) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.get(`/envelope/available-files/${boardId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateInstanceId = async (payload) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.put(
      `/envelope/update-instance/${payload.envelopeId}`,
      { instanceId: payload.instanceId },
      {
        headers: {
          'Content-Type': 'application/json',
          sessionToken: token.data,
        },
      },
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getUploadedTemplateForGenerate = async (
  boardId,
  itemId,
  instanceId,
) => {
  try {
    const token = await getSessionToken();
    const res = await axios.get(`/board/${boardId}/${itemId}`, {
      params: {
        instanceId,
      },
      headers: {
        sessionToken: token.data,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getUploadedTemplate = async (boardId, itemId, instanceId) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.get(`/envelope/${boardId}/${itemId}`, {
      params: {
        instanceId,
      },
      headers: {
        sessionToken: token.data,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const renameFileForGenerate = async ({ filename, fileId }) => {
  try {
    let url = `/board/file-rename/${fileId}`;
    const token = await getSessionToken();

    const res = await axios.put(
      url,
      { filename, type: 'generate' },
      {
        headers: {
          sessionToken: token.data,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const renameFileInEnvelope = async ({ fileName, fileId }) => {
  try {
    let url = `/file/rename-file/${fileId}`;
    const token = await getSessionToken();

    const res = await axios_v2.patch(
      url,
      { file_name: fileName },
      {
        headers: {
          sessionToken: token.data,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFileInEnvelope = async ({ fileId, envelopeId, itemId }) => {
  try {
    let url = `/file/delete-file/${envelopeId}/${fileId}/${itemId}`;
    const token = await getSessionToken();

    const res = await axios_v2.put(
      url,
      {},
      {
        headers: {
          sessionToken: token.data,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFileInEnvelopeForAdhoc = async ({ assetId, envelopeId }) => {
  try {
    let url = `/adhoc/remove-file/${envelopeId}/${assetId}`;
    const token = await getSessionToken();

    const res = await axios_v2.delete(url, {
      headers: {
        sessionToken: token.data,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const renameFileInEnvelopeForAdhoc = async ({ assetId, envelopeId }) => {
  try {
    let url = `/adhoc/rename-file/${envelopeId}/${assetId}`;
    const token = await getSessionToken();

    const res = await axios_v2.put(
      url,
      {},
      {
        headers: {
          sessionToken: token.data,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFile = async (id) => {
  try {
    const token = await getSessionToken();
    const res = await axios.delete(`/files/${id}`, {
      headers: {
        sessionToken: token.data,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const addSenderDetails = async (payload) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.put(
      `/envelope/update-envelope-config`,
      JSON.stringify(payload),
      {
        headers: {
          'Content-Type': 'application/json',
          sessionToken: token.data,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const forceUpdateSenderDetails = async (payload) => {
  try {
    const token = getSessionToken();
    const res = await axios.put(
      `/files/${payload.id}/force-update`,
      JSON.stringify(payload.body),
      {
        headers: {
          'Content-Type': 'application/json',
          sessionToken: token.data,
        },
      },
    );

    return res.data;
  } catch (err) {
    throw err;
  }
};

export const uploadLogo = async (payload) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.post(`/envelope/upload-logo`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const uploadNewFileLogo = async (payload) => {
  try {
    const token = await getSessionToken();
    const res = await axios.post(`/files/new-file/upload-logo`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};
export const deleteLogo = async (envelopeId) => {
  try {
    const token = await getSessionToken();

    return axios_v2.post(
      `/envelope/delete-logo/${envelopeId}`,
      {},
      {
        headers: {
          sessionToken: token.data,
        },
      },
    );
  } catch (error) {
    throw error;
  }
};

export const getLogo = async (envelopeId) => {
  try {
    const token = await getSessionToken();

    const res = await axios_v2.get(`/envelope/logo/${envelopeId}`, {
      headers: {
        sessionToken: token.data,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getEnvelopFiles = async ({ envelopeId }) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.get(`/envelope/attached-files/${envelopeId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getEnvelopFilesForAdhoc = async ({ envelopeId }) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.get(`/adhoc/get-files/${envelopeId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const uploadFileInEnvelope = async ({ envelopeId, formData }) => {
  try {
    const token = await getSessionToken();
    const res = await axios_v2.post(`/file/add-file-to-envelope`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        sessionToken: token.data,
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteMultipleFileInEnvelopeForAdhoc = async ({
  assetIds,
  envelopeId,
}) => {
  try {
    let url = `/adhoc/remove-multiple-files/${envelopeId}`;
    const token = await getSessionToken();

    const res = await axios_v2.post(
      url,
      {
        deletingAssetIds: assetIds,
      },
      {
        headers: {
          sessionToken: token.data,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
